export { default as authentication } from './modules/authentication';
export { default as MainMenu } from './modules/MainMenu';
export { default as CTXMenu } from './modules/contextMenu';
export { default as modal } from './modules/modal';
export { default as group } from './modules/group';



// WEBPACK FOOTER //
// ./src/redux/index.js